<template>
  <div class="docs">
  </div>
</template>

<script>
import EventBus from "../bus";
import functions from '../mixins/functions';
export default {
  name: 'docs',
  mixins: [functions],
  data () {
    return {
    }
  },
  created: function (){
    this.resetBar();
  },
  mounted: function () {
    EventBus.$emit("checklogin")
    this.$store.state.heading = "Dokumente"
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Docs.vue